'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of integration
 */ const Integration = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 105 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.7676",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3792_5096)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M71.161 44.7379L66.1509 49.7479C66.927 51.8408 67.2562 54.0971 67.1385 56.3318L74.9455 48.5248C79.9556 43.5148 79.9315 35.3545 74.9215 30.3469C69.9114 25.3368 61.7752 25.3368 56.7652 30.3469L46.2309 40.8836C43.1984 43.9161 41.997 48.0803 42.6337 52.0066C42.8908 53.6766 43.5036 55.3226 44.4455 56.7812C44.9381 57.6054 45.5268 58.3335 46.2333 59.0399L48.2805 61.0848L52.0195 57.3459L49.9722 55.301C49.2441 54.5705 48.7035 53.7487 48.3502 52.8789C47.2209 50.1516 47.7856 46.8596 49.9962 44.6489L60.5329 34.1122C63.4717 31.1735 68.2222 31.1735 71.1634 34.1122C74.1021 37.051 74.1021 41.8015 71.1634 44.7427L71.161 44.7379Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M62.3426 53.5589C62.1071 51.8648 61.4968 50.2669 60.5789 48.7843C60.0863 47.9625 59.4736 47.208 58.7671 46.504L56.7439 44.4807L52.9809 48.2437L55.0042 50.2669C55.7322 50.995 56.2969 51.8432 56.6261 52.7371C57.7555 55.4644 57.1908 58.7107 54.9801 60.9213L44.4434 71.4581C41.5047 74.3968 36.7541 74.3968 33.813 71.4581C30.8718 68.5193 30.8718 63.7688 33.813 60.8276L38.823 55.8176C38.0709 53.7006 37.7417 51.4419 37.8595 49.2553L30.0525 57.0623C25.0424 62.0723 25.0424 70.2086 30.0525 75.2186C35.0625 80.2286 43.2227 80.2503 48.2304 75.2426L58.7647 64.7059C61.7972 61.6711 62.9746 57.4876 62.3402 53.5589H62.3426Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M34.5362 38.5915C35.0553 39.1105 35.7353 39.37 36.4177 39.37C37.1001 39.37 37.7802 39.1105 38.2992 38.5915C39.3396 37.551 39.3396 35.8666 38.2992 34.8286L33.9139 30.4433C32.8758 29.4052 31.1914 29.4028 30.1509 30.4433C29.1105 31.4837 29.1105 33.1681 30.1509 34.2062L34.5362 38.5915Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M30.5927 49.0668C31.7317 49.0668 32.7866 48.3292 33.1374 47.183C33.5675 45.7773 32.777 44.2899 31.3713 43.8598L25.4409 42.0456C24.0352 41.6179 22.5478 42.4084 22.1177 43.8117C21.6876 45.2174 22.4781 46.7048 23.8838 47.1349L29.8142 48.9491C30.0737 49.0284 30.3356 49.0668 30.5927 49.0668Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M43.5662 31.6647C43.917 32.8109 44.9719 33.5486 46.1108 33.5486C46.368 33.5486 46.6299 33.5101 46.8894 33.4308C48.2951 33.0007 49.0856 31.5133 48.6555 30.1076L46.8413 24.1749C46.4112 22.7692 44.9238 21.9786 43.5181 22.4087C42.1124 22.8388 41.3219 24.3262 41.752 25.7319L43.5662 31.6647Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M70.4642 66.996C69.4261 65.9555 67.7417 65.9579 66.7012 66.996C65.6608 68.0364 65.6608 69.7209 66.7012 70.7589L71.0865 75.1442C71.6056 75.6633 72.2856 75.9228 72.968 75.9228C73.6504 75.9228 74.3304 75.6633 74.8495 75.1442C75.8899 74.1038 75.8899 72.4193 74.8495 71.3813L70.4642 66.996Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M81.1164 58.4516L75.186 56.6374C73.7827 56.2097 72.2929 57.0002 71.8628 58.4035C71.4327 59.8092 72.2233 61.2966 73.629 61.7267L79.5593 63.5409C79.8188 63.6202 80.0807 63.6586 80.3379 63.6586C81.4768 63.6586 82.5317 62.921 82.8825 61.7748C83.3126 60.3691 82.5221 58.8817 81.1164 58.4516Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M61.4341 73.9225C61.004 72.5168 59.5166 71.7287 58.1109 72.1564C56.7052 72.5865 55.9146 74.0739 56.3448 75.4796L58.1589 81.4123C58.5098 82.5585 59.5646 83.2962 60.7036 83.2962C60.9607 83.2962 61.2226 83.2578 61.4822 83.1785C62.8879 82.7484 63.6784 81.261 63.2483 79.8553L61.4341 73.9225Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3792_5096",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "61",
                        height: "61",
                        fill: "white",
                        transform: "translate(22 22.293)"
                    })
                })
            })
        ]
    });
};

exports.Integration = Integration;
//# sourceMappingURL=Integration.cjs.map
